import Helper from "@/common/helper.js";

export default class SubscriberModel {
    memberId: string = "";
    memberNumber: string = "";
    firstName: string = "";
    lastName: string = "";
    email: string = "";
    title: string = "";
    categoryName: string = "";
    startTimestamp: number = 0;
    nextRenewalTimestamp: number = 0;
    canceledTimestamp: number = 0;
    maskedCard: string = "";
    cardType: string = "";

    static readonly DATE_TIME_FORMAT = "MM/DD/YYYY";

    get isActive(): boolean {
        return this.canceledTimestamp <= 0;
    }

    get statusLabel(): string {
        return this.isActive ? "Active" : "Cancelled";
    }

    get startDateDisplay(): string {
        return Helper.convertUTCDateToLocalDateFormat(new Date(this.startTimestamp), SubscriberModel.DATE_TIME_FORMAT);
    }

    get renewsOnDisplay(): string {
        if (!this.isActive) return "-";
        return Helper.convertUTCDateToLocalDateFormat(new Date(this.nextRenewalTimestamp), SubscriberModel.DATE_TIME_FORMAT);
    }

    static from(json: string): SubscriberModel {
        return Object.assign(new SubscriberModel(), json);
    }
}
